// extracted by mini-css-extract-plugin
export var blurbElement = "blurbElement-module--blurbElement--a608d";
export var blurbSubheadline = "blurbElement-module--blurbSubheadline--6479f";
export var blurbTextContainer = "blurbElement-module--blurbTextContainer--f8b57";